import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialXRoundedIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M10.9254 2.05567C7.40155 2.42329 4.25294 4.7425 2.82158 8.02447C1.89917 10.1433 1.74566 12.5829 2.40062 14.8289C3.20964 17.6293 5.30239 19.9953 8.01025 21.1787C10.1297 22.1008 12.5702 22.2543 14.817 21.5995C18.1798 20.6303 20.8276 17.8701 21.6968 14.441C23.0538 9.06717 19.7243 3.57254 14.3353 2.28961C13.1516 2.00889 12.1091 1.93523 10.9254 2.05567ZM11.0591 8.26509C11.9147 9.40137 12.637 10.3371 12.6638 10.3371C12.6905 10.3371 13.58 9.40137 14.6295 8.26509L16.5484 6.19306H17.6382L17.4042 6.44063C17.2705 6.58046 16.4013 7.52304 15.4719 8.53245C14.5426 9.54173 13.6333 10.524 13.4525 10.7047L13.1318 11.0456L15.6391 14.3809C17.0164 16.219 18.1464 17.7427 18.1464 17.77C18.1464 17.8034 17.3242 17.8232 16.3275 17.8232L14.5024 17.8165L12.8042 15.5439C11.6341 13.9732 11.0859 13.2977 11.0324 13.3382C10.9922 13.3717 10.0426 14.3946 8.91956 15.6108L6.8803 17.8232H6.36521C6.07797 17.8232 5.84396 17.8095 5.84396 17.7898C5.84396 17.77 6.90705 16.6064 8.20388 15.2097C9.4947 13.8128 10.5645 12.6431 10.5774 12.6233C10.5844 12.596 9.52131 11.1459 8.21752 9.40137C6.91373 7.66353 5.84396 6.22648 5.84396 6.21284C5.84396 6.19988 6.66608 6.19306 7.67595 6.19306H9.50767L11.0591 8.26509Z"
            fill="#222"
          />
          <path
            d="M7.49569 7.08871C7.5223 7.1355 9.20679 9.39468 11.2263 12.0947L14.9036 17.0143L15.7257 17.0211C16.234 17.0211 16.5417 16.9944 16.5281 16.9543C16.5219 16.9208 14.8436 14.6619 12.8111 11.9413L9.1065 6.99514H8.2777C7.5893 6.99514 7.44862 7.00877 7.49569 7.08871Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
